<template>
  <form novalidate="true" autocomplete="off">
    <slot />
  </form>
</template>

<script>
export default {
  name: "FormValidator",
  data() {
    return {
      elements: [],
      mountedElements: [],
      checkedUids: [],
      validForm: null
    };
  },
  updated() {
    if (this.validForm !== null) {
      this.autoValidate();
    }
  },
  methods: {
    refreshMountedElements() {
      this.checkedUids = [];
      this.mountedElements = this.elements.filter(el => {
        // Filtrar todos los elementos que no estan "destruidos"
        return !el._isDestroyed;
      });
    },
    autoValidate() {
      let validForm = true;
      for (let element of this.mountedElements) {
        if (!element.checkValid) {
          this.$log.error(
            `No se implementó la función checkValid en el elemento: ${element.$options.name}`
          );
        } else {
          if (!element.checkValid()) {
            validForm = false;
          }
        }
      }

      this.validForm = validForm;
    },
    validate() {
      this.refreshMountedElements();
      let validForm = true;
      let primeroEnError = null;

      for (let element of this.mountedElements) {
        if (!element.checkValid) {
          this.$log.error(
            `No se implementó la función checkValid en el elemento: ${element.$options.name}`
          );
        } else {
          if (!element.checkValid()) {
            if (!primeroEnError) {
              primeroEnError = element;
            }
            validForm = false;
          }
        }
      }

      // Si ya sé que el form no es válido
      if (!validForm) {
        // Scrolleo al primero en error
        primeroEnError.$el.scrollIntoView(false);
      }

      this.validForm = validForm;
      return validForm;
    },
    subscribe(el) {
      this.elements.push(el);
    }
  }
};
</script>
